import type { MenuItemType } from '#base/core/types/MenuItemType';

export default (): MenuItemType[] => {
	const items: MenuItemType[] = [];

	items.push({
		to: {
			url: 'https://werkhier.com',
			title: 'Fysio Hier vacatures',
			newTab: true,
		},
		text: 'Werken bij Fysio Hier',
		counter: countVacancies('fysio'),
	});

	items.push({
		to: {
			url: '/fysiotherapie/behandelingen',
			title: 'Fysiotherapie behandelingen',
		},
		text: 'Behandelingen',
	});

	items.push({
		to: {
			url: '/fysiotherapie/tarieven',
			title: 'Bekijk de tarieven voor fysiotherapie',
		},
		text: 'Tarieven',
	});

	items.push({
		to: {
			url: '/fysiotherapie/pijnklachten-fysieke-beperkingen',
			title: 'Veelvoorkomende fysieke klachten',
		},
		text: 'Veelvoorkomende klachten',
	});

	items.push({
		to: {
			url: '/werkgebied',
			title: 'Fysio Hier werkgebied',
		},
		text: 'Werkgebied',
	});

	items.push({
		to: {
			url: '/blog',
			title: 'Fysio Hier blog',
		},
		text: 'Blog & laatste nieuws',
	});

	items.push({
		to: {
			url: '/algemene-voorwaarden',
			title: 'Fysio Hier algemene voorwaarden',
		},
		text: 'Algemene voorwaarden',
	});

	items.push({
		to: {
			url: '/privacy-beleid',
			title: 'Fysio Hier privacy beleid',
		},
		text: 'Privacy beleid',
	});

	items.push({
		to: {
			url: '/cookie-instellingen',
			title: 'Cookie instellingen',
		},
		text: 'Cookie instellingen',
	});

	items.push({
		to: {
			url: '/huisregels',
			title: 'Fysio Hier huisregels',
		},
		text: 'Huisregels',
	});

	items.push({
		to: {
			url: 'https://fithier.com',
			title: 'Fit Hier, sporten met een trainer',
			newTab: true,
		},
		text: 'Fit Hier',
	});

	return items;
};
